export default __webpack_public_path__ + "static/media/tbone.dae3db59.svg";